import { render, staticRenderFns } from "./PartnersBlock.vue?vue&type=template&id=aeb08cd2"
import script from "./PartnersBlock.vue?vue&type=script&lang=js"
export * from "./PartnersBlock.vue?vue&type=script&lang=js"
import style0 from "./PartnersBlock.vue?vue&type=style&index=0&id=aeb08cd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports